import { type ComponentProps, type ReactNode } from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import {
  PageHeader,
  PageContainer,
} from '@leagueplatform/web-common-components';
import { SECONDARY_CONTENT_MAX_WIDTH } from 'common/constants';

// Shared shell for the secondary settings pages (Personal Info, Communication
// Preferences, Notifications): a PageHeader band over a PageContainer holding a
// single content column centered and capped at SECONDARY_CONTENT_MAX_WIDTH.
// Centralizing it keeps the layout — and the PageContainer choice — consistent
// in one place rather than re-inlined per page.
export const SettingsPageLayout = ({
  heading,
  spacing,
  children,
}: {
  heading: string;
  // Forwarded to the content column; pages with multiple stacked cards set
  // their own (e.g. responsive) spacing.
  spacing?: ComponentProps<typeof StackLayout>['spacing'];
  children: ReactNode;
}) => (
  <>
    <PageHeader heading={heading} />
    <PageContainer css={{ paddingBlockStart: '$two' }}>
      <StackLayout
        horizontalAlignment="stretch"
        spacing={spacing}
        css={{
          width: '100%',
          maxWidth: SECONDARY_CONTENT_MAX_WIDTH,
          marginInline: 'auto',
        }}
      >
        {children}
      </StackLayout>
    </PageContainer>
  </>
);
